import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ham-general-confirm-decline-modal-body',
    templateUrl: './ham-general-confirm-decline-modal-body.component.html',
    styleUrls: ['./ham-general-confirm-decline-modal-body.component.scss'],
})
export class HamGeneralConfirmDeclineModalBodyComponent implements OnInit {
    @Input() text: string;
    @Input() icon: string = 'gray-trash-big-icon';
    @Input() useIconShapes: boolean = false;
    @Input() iconShapeVariant: string = 'primary';

    constructor() { }

    ngOnInit(): void { }
}
